import React from 'react';
import { Typography } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { ClassNameMap } from '@mui/styles';
import { formatTimeFromIsoString } from 'utils/date-time';
import { useMeContext } from 'modules/me';
import { useFormattedDuration } from 'modules/notes/common';

type NoteTimeDurationProps = {
  testId?: string;
  classes?: ClassNameMap;
  startTime?: string;
  endTime?: string;
  duration?: number | null;
};

const useStyles = makeStyles({
  root: {},
  time: {},
  duration: {}
});
export const NoteTimeDuration: React.FC<NoteTimeDurationProps> = ({
  testId,
  classes: overrideClasses,
  startTime,
  endTime,
  duration
}: NoteTimeDurationProps) => {
  const classes = useStyles({ classes: overrideClasses });
  const me = useMeContext();
  const formattedDuration = useFormattedDuration({
    needsMask: true,
    duration: duration ?? 0
  });

  return (
    <div className={classes.root} data-testid={testId}>
      {startTime && endTime && (
        <Typography
          data-testid="start-and-end-time"
          className={classes.time}
          variant={'caption'}
          color={'textSecondary'}
          noWrap
        >
          {formatTimeFromIsoString(startTime, me)}
          &nbsp; &ndash; &nbsp;
          {formatTimeFromIsoString(endTime, me)}
        </Typography>
      )}
      <Typography
        data-testid="duration"
        variant="body2"
        className={classes.duration}
      >
        {duration ? formattedDuration : ''}
      </Typography>
    </div>
  );
};
